export default {
    API_DOCS_CACHING_TIME: 600000,
    APP_LIST_CACHING_TIME: 180000,
}